import { useState } from "react";

export default function Section18() {
  const faqs = [
    {
      question: "What types of websites and applications can you develop for Texas businesses?",
      answer:
        "We build custom websites, responsive web applications, ecommerce platforms, and enterprise-level solutions tailored to your business needs and growth goals.",
    },
    {
      question: "How long does it take to complete a custom web development project?",
      answer:
        "Project timelines vary depending on complexity and features. Simple websites may take 4–6 weeks, while larger applications or enterprise platforms typically require 3–6 months.",
    },
    {
      question: "Can you integrate third-party tools like CRMs, ERPs, or payment gateways?",
      answer:
        "Yes. We connect your website or application with essential business systems to automate workflows, streamline operations, and enhance functionality without affecting performance.",
    },
    {
      question: "How do you handle post-launch enhancements or feature requests?",
      answer:
        "We offer ongoing support and development packages, allowing you to add features, improve UX, or scale your platform as your business grows without disruptions.",
    },
    {
      question: "Can you migrate my existing website to a new platform?",
      answer:
        "Yes. We handle platform migrations carefully, ensuring all content, data, and SEO structures are preserved while improving performance, UX, and scalability",
    },
   
  ];

  const [isOpen, setIsOpen] = useState(new Array(faqs.length).fill(false));

  const handleFaq = (index) => {
    setIsOpen((prevState) =>
      prevState.map((item, idx) => (idx === index ? !item : false))
    );
  };

  return (
    <div className="w-full SectionWebsiteFAQs mt-[8%] md:mt-[-4%]">
      <div className="w-full section-container">
        <div className="w-[90%] md:w-[61%] pb-[1%] mx-auto text-center">
          <h2 className="leading-[29px] md:leading-[41px] text-[24px] md:text-[30px] text-[#151515] font-bold my-[0.67em]">
            Frequently Asked Questions about Website Development
          </h2>
        </div>

        <div className="w-full md:w-[784px] p-5 md:p-[2%] mx-auto faq-container font-open leading-[21px]">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="faq-item text-[11px] md:text-sm rounded-[8px] p-[2%] border border-solid border-[#DEDEDE] mb-[4%]"
              // style={{
              //   background:
              //     "linear-gradient(0deg, #FEFFFF, #FEFFFF), linear-gradient(0deg, #DEDEDE, #DEDEDE)",
              // }}
            >
              <div
                onClick={() => handleFaq(index)}
                className="question text-[#444444] cursor-pointer flex justify-between items-center"
              >
                {faq.question}
                <b className="text-[40px] text-[#DA2128] font-[300]">
                  {isOpen[index] ? "-" : "+"}
                </b>
              </div>
              <div className={`${isOpen[index] ? "block" : "hidden"} answer text-[#444444]`}>
                <br />
                <p className="mb-5">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center mt-8">
          <a
            href="https://mean3.com/contact-mean3"  // replace with your desired link if different
            className="bg-[#DA2128] hover:bg-[#b71c22] text-white px-8 py-3 rounded-lg font-semibold text-[15px] md:text-[16px] transition-all duration-300 inline-block text-center"
          >
            Ask Your Question
          </a>

        </div>
      </div>

      {/* Divider Line */}
      <div className="line mb-[55px] md:mb-[4%] mt-[1%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
